module.exports = __webpack_public_path__ + "img/cloud_logo@2x.fd11bbe6.png";